import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Switch, Route, BrowserRouter } from "react-router-dom";

import { NewList } from "./pages/new-list";
import { Editor } from "./pages/editor";
import { Home } from "./pages/home";
import { Unit } from "./pages/unit";
import { EditList } from "./pages/edit-list";
import { Magic } from "./pages/magic";
import { About } from "./pages/about";
import { Add } from "./pages/add";
import { Help } from "./pages/help";
import { Export } from "./pages/export";
import { Print } from "./pages/print";
import { DuplicateList } from "./pages/duplicate-list";
import { Rename } from "./pages/rename";
import { Datasets } from "./pages/datasets";
import { NotFound } from "./pages/not-found";
import { Privacy } from "./pages/privacy";
import { Changelog } from "./pages/changelog";
import { Import } from "./pages/import";
import { GameView } from "./pages/game-view";
import { CustomDatasets } from "./pages/custom-datasets";
import { BattleTavern } from "./pages/battle-tavern/BattleTavern";
import { Settings } from "./pages/settings";
import { setLists } from "./state/lists";
import { setSettings } from "./state/settings";
import { Header, Main } from "./components/page";

import {
  useDropboxAuthentication,
  syncLists,
} from "./utils/dropbox-auth-and-synchronization";

import "./App.css";

let intervalId = null;
let isWindowActive = true;
const autoSyncLists = ({ dispatch }) => {
  intervalId = setInterval(() => {
    // const settings = JSON.parse(localStorage.getItem("owb.settings"));
    // const lastChanged = new Date(settings.lastChanged).getTime();
    // const lastSynced = new Date(settings.lastSynced).getTime();

    // if (lastChanged > lastSynced) {
    if (isWindowActive) {
      syncLists({ dispatch });
    }
  }, 30000);
};

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    isWindowActive = true;
  } else if (document.visibilityState === "hidden") {
    isWindowActive = false;
  }
});

export const App = () => {
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 1279px)").matches,
  );
  const settings = useSelector((state) => state.settings);
  useDropboxAuthentication();

  useEffect(() => {
    const localLists = localStorage.getItem("owb.lists");
    const localSettings = localStorage.getItem("owb.settings");

    dispatch(setLists(JSON.parse(localLists)));
    dispatch(setSettings(JSON.parse(localSettings)));
  }, [dispatch]);

  useEffect(() => {
    if (settings.autoSync && !intervalId) {
      autoSyncLists({ dispatch });
    }
  }, [settings.autoSync, dispatch]);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 1279px)");

    if (mediaQuery?.addEventListener) {
      mediaQuery.addEventListener("change", (event) =>
        setIsMobile(event.matches),
      );
    } else {
      mediaQuery.addListener((event) => setIsMobile(event.matches));
    }
  }, []);

  return (
    <BrowserRouter>
      {isMobile ? (
        <Switch>
          <Route path="/editor/:listId/edit">{<EditList isMobile />}</Route>
          <Route path="/editor/:listId/export">{<Export isMobile />}</Route>
          <Route path="/editor/:listId/duplicate">
            {<DuplicateList isMobile />}
          </Route>
          <Route path="/editor/:listId/add/:type">{<Add isMobile />}</Route>
          <Route path="/editor/:listId/:type/:unitId/magic/:command">
            {<Magic isMobile />}
          </Route>
          <Route path="/editor/:listId/:type/:unitId/rename">
            {<Rename isMobile />}
          </Route>
          <Route path="/editor/:listId/:type/:unitId/items/:group">
            {<Magic isMobile />}
          </Route>
          <Route path="/editor/:listId/:type/:unitId">
            {<Unit isMobile />}
          </Route>
          <Route path="/editor/:listId">{<Editor isMobile />}</Route>
          <Route path="/import">{<Import isMobile />}</Route>
          <Route path="/new">{<NewList isMobile />}</Route>
          <Route path="/about">{<About />}</Route>
          <Route path="/help">{<Help />}</Route>
          <Route path="/custom-datasets">{<CustomDatasets />}</Route>
          <Route path="/settings">{<Settings />}</Route>
          <Route path="/privacy">{<Privacy />}</Route>
          <Route path="/datasets">{<Datasets isMobile />}</Route>
          <Route path="/changelog">{<Changelog />}</Route>
          <Route path="/print/:listId">{<Print />}</Route>
          <Route path="/game-view/:listId">{<GameView />}</Route>
          <Route path="/battletavern">{<BattleTavern />}</Route>
          <Route path="/" exact>
            {<Home isMobile />}
          </Route>
          <Route path="*">{<NotFound />}</Route>
        </Switch>
      ) : (
        <Switch>
          <Route path="/about">{<About />}</Route>
          <Route path="/help">{<Help />}</Route>
          <Route path="/custom-datasets">{<CustomDatasets />}</Route>
          <Route path="/settings">{<Settings />}</Route>
          <Route path="/privacy">{<Privacy />}</Route>
          <Route path="/datasets">{<Datasets />}</Route>
          <Route path="/changelog">{<Changelog />}</Route>
          <Route path="/print/:listId">{<Print />}</Route>
          <Route path="/game-view/:listId">{<GameView />}</Route>
          <Route path="/battletavern">{<BattleTavern />}</Route>
          <Route path="/">
            <Header headline="Old World Builder" hasMainNavigation />
            <Main isDesktop>
              <section className="column">
                <Home />
              </section>
              <section className="column">
                <Switch>
                  <Route path="/new">{<NewList />}</Route>
                  <Route path="/import">{<Import />}</Route>
                  <Route path="/editor/:listId">{<Editor />}</Route>
                </Switch>
              </section>
              <section className="column">
                <Switch>
                  <Route path="/editor/:listId/edit">{<EditList />}</Route>
                  <Route path="/editor/:listId/export">{<Export />}</Route>
                  <Route path="/editor/:listId/duplicate">
                    <DuplicateList />
                  </Route>
                  <Route path="/editor/:listId/add/:type">{<Add />}</Route>
                  <Route path="/editor/:listId/:type/:unitId">{<Unit />}</Route>
                </Switch>
              </section>
              <section className="column">
                <Switch>
                  <Route path="/editor/:listId/:type/:unitId/magic/:command">
                    <Magic />
                  </Route>
                  <Route path="/editor/:listId/:type/:unitId/rename">
                    <Rename />
                  </Route>
                  <Route path="/editor/:listId/:type/:unitId/items/:group">
                    <Magic />
                  </Route>
                </Switch>
              </section>
            </Main>
          </Route>
        </Switch>
      )}
    </BrowserRouter>
  );
};
